// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__mZeO0","bigColWidth":"Table_bigColWidth__3euU-","biggerColWidth":"Table_biggerColWidth__2RXfX","row":"Table_row__2R5wk","col":"Table_col__3buuZ"};